<template>
  <div class="navigation">
    <div class="navigation_center">
      <div class="navig_1">
        <router-link to="/">
          <img :src="require('@/assets/images/logo.png')" alt="Happy Lottery">
        </router-link>
      </div>
      <div class="menu-toggle" @click="toggleMenu">
        <i :class="['el-icon-menu', {'el-icon-close': menuOpen}]"></i>
      </div>
      <div class="navig_2" :class="{ 'show-mobile-menu': menuOpen }">
        <router-link to="/games/lucky-ball-5" :class="{ active: $route.path.includes('/games') }" @click="closeMenu">Games</router-link>
        <router-link to="/results/lucky-ball-5" :class="{ active: $route.path.includes('/results') }" @click="closeMenu">Results</router-link>
        <router-link to="/about/about-lucky-lottery" :class="{ active: $route.path.includes('/about') }" @click="closeMenu">About</router-link>
        <router-link to="/help/how-to-play" :class="{ active: $route.path.includes('/help') }" @click="closeMenu">Help</router-link>
      </div>
      <div class="navig_3" :class="{ 'show-mobile-menu': menuOpen }">
        <router-link to="/about/responsible-play-program" class="responsible-play" @click="closeMenu">
          RESPONSIBLE<br>PLAY >
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      menuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      document.body.style.overflow = this.menuOpen ? 'hidden' : '';
    },
    closeMenu() {
      this.menuOpen = false;
      document.body.style.overflow = '';
    }
  }
}
</script>

<style scoped>
.navigation {
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #f1f1f1;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.navigation_center {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  box-sizing: border-box;
}

.navig_1 img {
  height: 50px;
}

.navig_2 {
  display: flex;
  gap: 60px;
}

.navig_2 a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  position: relative;
  font-weight: 500;
}

.navig_2 a.active {
  color: #e03997;
}

.navig_2 a.active::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #e03997;
}

.responsible-play {
  display: inline-block;
  padding: 8px 12px;
  border: 1px solid #e03997;
  border-radius: 3px;
  color: #e03997;
  text-decoration: none;
  text-align: center;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 500;
}

.menu-toggle {
  display: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
}

@media (max-width: 768px) {
  .menu-toggle {
    display: block;
    z-index: 1001;
  }
  
  .navig_2 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(255,255,255,0.97);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }
  
  .navig_2.show-mobile-menu {
    opacity: 1;
    visibility: visible;
  }
  
  .navig_2 a {
    opacity: 0;
    transform: translateY(10px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    transition-delay: 0.1s;
  }
  
  .navig_2.show-mobile-menu a {
    opacity: 1;
    transform: translateY(0);
  }
  
  .navig_2.show-mobile-menu a:nth-child(2) {
    transition-delay: 0.2s;
  }
  
  .navig_2.show-mobile-menu a:nth-child(3) {
    transition-delay: 0.3s;
  }
  
  .navig_2.show-mobile-menu a:nth-child(4) {
    transition-delay: 0.4s;
  }
  
  .navig_3 {
    display: none;
  }
  
  .navig_3.show-mobile-menu {
    display: block;
    position: fixed;
    bottom: 80px;
    left: 0;
    width: 100%;
    text-align: center;
    z-index: 1000;
    animation: fadeInUp 0.5s ease forwards;
    animation-delay: 0.5s;
    opacity: 0;
  }
  
  .navig_2 a.active::after {
    bottom: -5px;
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

@media (max-width: 576px) {
  .navig_1 img {
    height: 40px;
  }
  
  .navigation_center {
    padding: 10px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/NavBar.vue